import React from "react";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Forgot,
  Form,
  LoginSection,
  Title,
  Subtitle,
  Disclaimer,
  Copyright
} from "./LoginStyles";
import DefaultInput from "../Inputs/DefaultInput";
import ButtonComponent from "../Buttons/ButtonComponent";
import { login } from "../../services/AuthService";
import ToastService from "../../services/ToastService";
import { loginSuccess } from ".././../redux/user/user.actions";
import { BodyScroll } from "../../components/Utils";
import DefaultCheckbox from "../Inputs/DefaultCheckbox";
import { startSocketIO } from "../../services/SocketIOService";
import { startPushNotificationService } from "../../services/PushNotificationService";
import { notificationStart } from "../../services/NotificationService";
import { FooterText } from "../../pages/layout/FooterText";

const validation = values => {
  const errors = {};

  if (!values.terms) {
    errors.terms = "REQUIRED";
  }

  if (!values.email) {
    errors.email = "REQUIRED";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "INVALID_ADDRESS";
  }

  if (!values.password) {
    errors.password = "REQUIRED";
  } else if (values.password.length < 6) {
    errors.password = "PASSWORD_MIN_LENGTH";
  }

  return errors;
};

class LoginForm extends React.Component {
  state = {
    loading: false
  };

  onSubmit = values => {
    const { history, loginSuccess } = this.props;
    this.setState({ loading: true }, () => {
      login(values)
        .then(result => {
          localStorage.setItem(
            process.env.REACT_APP_AUTH_TOKEN,
            result.data.token
          );
          loginSuccess(result.data.member);
          startSocketIO(result.data.token);
          notificationStart();
          startPushNotificationService();
          this.setState({ loading: false }, () => {
            history.push("/wall");
            BodyScroll(false);
          });
        })
        .catch(error => {
          ToastService.error("Invalid Credentials");
          this.setState({ loading: false });
        });
    });
  };

  renderLabel = () => {
    const { history, onClose } = this.props;
    return (
      <span>
        By login you agree to EFRS's{" "}
        <a
          onClick={() => {
            onClose();
            history.push("terms");
          }}
        >
          Terms and Conditions
        </a>
        .
      </span>
    );
  };

  render() {
    const { handleSubmit, toggle } = this.props;
    const { loading } = this.state;
    return (
      <LoginSection>
        <Title>Welcome!</Title>
        <Subtitle>Please login with your account.</Subtitle>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            component={DefaultInput}
            name="email"
            type="email"
            label="Email"
          />
          <Field
            component={DefaultInput}
            name="password"
            type="password"
            label="Password"
          />
          <Field
            component={DefaultCheckbox}
            secondary
            name="terms"
            label={this.renderLabel()}
          />
          <Forgot onClick={toggle}>Forgot Password?</Forgot>
          <ButtonComponent loading={loading} width="180px" label="Login" />
        </Form>
        <Disclaimer>
          <Copyright>
            <FooterText />
          </Copyright>
        </Disclaimer>
      </LoginSection>
    );
  }
}

LoginForm = reduxForm({
  form: "login_form",
  enableReinitialize: true,
  validate: validation
})(LoginForm);

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

const mapActionToProps = dispatch =>
  bindActionCreators({ loginSuccess }, dispatch);

LoginForm = connect(
  mapStateToProps,
  mapActionToProps
)(LoginForm);

export default withRouter(LoginForm);



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js